var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDownloadTemplate
    ? _c(
        "modal-box",
        {
          attrs: { open: _vm.showDownloadTemplate },
          domProps: {
            onClose: _vm.hideDownloadTemplate,
            enableHeader: true,
            enableFooter: true,
            enableHeaderClose: true,
            transparentOverlay: false,
            closeOnClickOutside: true,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "flex-row flex-1" }, [
                _c("div", { staticClass: "flex-col flex-1" }, [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("downloadHydroDataTemplate"))),
                  ]),
                ]),
              ]),
            ]
          ),
          _c("div", [
            _c("div", { staticClass: "flex-col pr-1" }, [
              _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(" " + _vm._s(_vm.$t("hydroDataScenarioCodeInfo")) + " "),
              ]),
              _c("label", { attrs: { for: "reviewScenarioCode" } }, [
                _vm._v(_vm._s(_vm.$t("enterReviewScenarioCode"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reviewScenarioCode,
                    expression: "reviewScenarioCode",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "reviewScenarioCode" },
                domProps: { value: _vm.reviewScenarioCode },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.reviewScenarioCode = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("div", { staticClass: "flex-row reverse" }, [
                _c("div", { staticClass: "flex-col flex-align-end mt-1" }, [
                  _c(
                    "button",
                    { staticClass: "btn", on: { click: _vm.download } },
                    [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }